import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import defaultStyle from './paged-list.style';
import PagingControl from './paging-control';
import GenericError from './generic-error';
import Table from './table';

export class PagedList extends Component {

  render() {
    const { isLoading, loadingErr } = this.props;

    if(loadingErr) {
      return <GenericError err={loadingErr}/>
    }

    return(
      <div>
        <Table {...this.props}/>
        {!isLoading ? <PagingControl {...this.props} /> : null}
      </div>
    );
  }
}

PagedList.defaultProps = {
  loadingMessage : 'Loading...',
  contentLoadedMessage : 'Content Loaded',
}

PagedList.propTypes = {
  header: PropTypes.element.isRequired,
  items: PropTypes.array.isRequired,
  emptyMessage: PropTypes.element,
  loadingMessage: PropTypes.string,
  contentLoadedMessage: PropTypes.string,
  mapItem: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  resultsPerPage: PropTypes.number.isRequired,
  totalItemsCount: PropTypes.number.isRequired,
  changePageNumber: PropTypes.func,
  changeResultsPerPage: PropTypes.func,
  variableResultsPerPage: PropTypes.bool,
  perPageOptions: PropTypes.array, // expects an array with objects containing a number 'value' and a string 'label'
  isLoading: PropTypes.bool.isRequired,
  loadingErr: PropTypes.object,
};

export default styleable(defaultStyle) (PagedList);
